import { makeStyles } from '@material-ui/core'
import { colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${colors.grey[400]}`,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    cursor: 'pointer',
    borderBottom: `1px solid ${colors.grey[400]}`,
  },
  headerClosed: {
    borderBottom: '0 none',
  },
  title: {
    fontWeight: 400,
  },
  toggleArea: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 4,
  },
  toggleLabel: {
    fontWeight: 400,
  },
  cookiesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: theme.spacing(2),
  },
  cookieBox: {
    backgroundColor: colors.grey[200],
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

export default styles
